import React, { useState } from 'react';
import { Box, Stack, Button, TextField } from '@mui/material';
import MyDatePicker from '../../atoms/Common/MyDatePicker';
import LGModal from '../../molecules/LGModal';

const DateFilterModal = ({ open, handleClose, onSubmit }) => {
    const [selectedDate, setSelectedDate] = useState(null);

    const handleSubmit = () => {
        if (selectedDate) {
            onSubmit(selectedDate);
            handleClose();
        }
    };

    return (
        <LGModal
            open={open}
            handleClose={handleClose}
            header="Filtrar por Mes/Año"
        >
            <Box p={2}>
                <MyDatePicker
                    views={['month', 'year']}
                    label="Mes/Año"
                    value={selectedDate}
                    onChange={(newValue) => setSelectedDate(newValue)}
                    renderInput={(params) => <TextField {...params} fullWidth />}
                />
                <Box mt={2} display="flex" justifyContent="flex-end">
                    <Stack direction="row" spacing={2}>
                        <Button onClick={handleClose} variant="outlined">
                            Cancelar
                        </Button>
                        <Button onClick={handleSubmit} variant="contained" color="primary">
                            Filtrar
                        </Button>
                    </Stack>
                </Box>
            </Box>
        </LGModal>
    );
};

export default DateFilterModal;
